import * as actionTypes from "./actionTypes";

export const getListProductAction = params => ({
	type: actionTypes.GET_LIST_PRODUCTS_ACTION,
	params
});

export const setListProductAction = params => ({
	type: actionTypes.SET_LIST_PRODUCTS_ACTION,
	params
});

export const setCartAction = params => ({
	type: actionTypes.SET_CART_ACTION,
	params
});

export const calculateCartAction = params => ({
	type: actionTypes.CALCULLATE_CART_ACTION,
	params
});

export const setCalculateCartAction = params => ({
	type: actionTypes.SET_CALCULLATE_CART_ACTION,
	params
});

export const setSelectProductDraftAction = params => ({
	type: actionTypes.SET_SELECT_PRODUCT_DRAFT_ACTION,
	params
});

export const getDataCalculateCartAction = () => ({
	type: actionTypes.GET_DATA_CALCALATE_CART_ACTION
});

export const setDataCalculateCartAction = params => ({
	type: actionTypes.SET_DATA_CALCALATE_CART_ACTION,
	params
});

export const postCreateOrderAction = params => ({
	type: actionTypes.POST_CREATE_ORDER_ACTION,
	params
});

export const getListHistoryOrderAction = params => ({
	type: actionTypes.GET_LIST_HISTORY_ORDER_ACTION,
	params
});

export const setListHistoryOrderAction = params => ({
	type: actionTypes.SET_LIST_HISTORY_ORDER_ACTION,
	params
});

export const setOrderHistoryDetailsAction = params => ({
	type: actionTypes.SET_ORDER_HISTORY_DETAIL_ACTION,
	params
});

export const getOrderHistoryDetailsAction = params => ({
	type: actionTypes.GET_ORDER_HISTORY_DETAIL_ACTION,
	params
});

export const setDataHistoryDetailsAction = params => ({
	type: actionTypes.SET_DATA_HISTORY_DETAIL_ACTION,
	params
});

export const setDataIdPromotionChoosesAction = params => ({
	type: actionTypes.SET_DATA_ID_PROMOTION_CHOOSES_ACTION,
	params
});

export const setDefaultCartAction = params => ({
	type: actionTypes.SET_DEFAULT_CART_ACTION,
	params
});

export const setMenuChildrenHistoryAction = params => ({
	type: actionTypes.SET_MENU_CHILDREN_HISTORY_ACTION,
	params
});

export const setMenuParentHistoryAction = params => ({
	type: actionTypes.SET_MENU_PARENT_HISTORY_ACTION,
	params
});

export const getMenuProductBrandsAction = params => ({
	type: actionTypes.GET_MENU_PRODUCT_BRANDS_ACTION,
	params
});

export const setMenuProductBrandsAction = params => ({
	type: actionTypes.SET_MENU_PRODUCT_BRANDS_ACTION,
	params
});
